import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataGrid } from "components/DataGrid/DataGrid";
import { Headerbar } from "components/Headerbar/Headerbar";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Toast } from "components/ToastShow/ToastAlert";
import { useEffect, useState } from "react";
import { ContactType, MessageType } from "types/enum";
import { getGridSetting, getPageSize, trans } from "utils/helpers";
import {
  deletePersonContact,
  getCustomerInProgressRequests,
  getCustomerInfo,
  getCustomerPhoneNumbers,
  setDefault,
} from "./api";
import { PhoneForm } from "./PhoneForm";
import { GUID_EMPTY } from "utils/constants";
import { getEnv } from "config/runtimeEnv";
import { callConnection } from "utils/callHub";


interface CustomerInfoForm {
  customerPositionId?: any;
}

export const CustomerInfo = ({ customerPositionId }: CustomerInfoForm) => {
  const [loading, setLoading] = useState(false);
  const [loadingPhoneNumbers, setLoadingPhoneNumbers] = useState(false);
  const [messageType, setMessageType] = useState<any>("info");
  const [messagePhoneNumbersType, setMessagePhoneNumbersType] = useState<any>("info");
  const [response, setResponse] = useState<any>();
  const [responseRequests, setResponseRequests] = useState<any>();
  const [requestsMessageType, setRequestsMessageType] = useState<any>();
  const [showPhoneForm,setShowPhoneForm]=useState<any>(false)
  const [forceUpdate,setForceUpdate]=useState(false)
  const [selectedObj,setSelectedObj]=useState<any>()
  const [presponseRequestsLoading,setPresponseRequestsLoading]=useState(false)
  const [responsePhoneNumbers, setResponsePhoneNumbers] = useState<any>();
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(25);
  const [search, setsearch] = useState(null);
  const [pages, setPages] = useState<number>(0);
  const [filterAndSort, setFilterAndSort] = useState<any>(null);
  const summarized =
    getEnv("REACT_APP_TADBIR_OWNER") != "true" ? true : false;
 let customFuction: any = [
      [
   (callConnection?._connectionState=="Connected" && (selectedObj?.ContactTypeEnum==ContactType.Mobile || selectedObj?.ContactTypeEnum==ContactType.Phone) )?  async (e) => {
       const res = await callConnection.invoke("OriginateCall" ,e?.Value);
      }:null,
      "phone",
      "call",
    ],
    [
      (e) => {
        setDefaultAsync(e.Id);
      },
      "map-pin",
      "setasdefault",
    ],

  ];
  async function getCustomerInfoAsync() {
    setLoading(false);

    try {
      const res = await getCustomerInfo(customerPositionId, summarized);
      if (summarized) {
        setResponse({ HeaderInfo: res.Data });
      } else {
        setResponse(res.Data);
      }

      const res2 = await getCustomerInProgressRequests(customerPositionId);
      if (res2.Data.length > 0) {
        setResponseRequests(res2.Data);
      }
    } catch (error) {
      setRequestsMessageType("error");
    }
    setLoading(true);
  }

      const handleChangePageSize = (e: any) => {
          setPageNum(1);
          setPageSize(e.currentTarget.value);
          getPageSize("ContactsInfoList", e.currentTarget.value)
          getCustomerPhoneNumbersAsync(1);
      };
      const handleGoPage = (value) => {
          if (value) {
              setPageNum(+value);
              getCustomerPhoneNumbersAsync(+value);
          } else {
          }
      };
      const handleNextPage = () => {
          if (responsePhoneNumbers.TotalRecords && ((responsePhoneNumbers.TotalRecords / pageSize) > pageNum)) {
              setPageNum((pageNum) => { return +pageNum + 1 });
              getCustomerPhoneNumbersAsync(pageNum + 1);
  
          }
      };
      const handlePrevPage = () => {
          if (pageNum > 1) {
              setPageNum((pageNum) => { return +pageNum - 1 });
              getCustomerPhoneNumbersAsync(pageNum - 1);
          }
      };
  
  


  async function getCustomerInProgressRequestsAsync() {
    setPresponseRequestsLoading(false);
    try {
      const res2 = await getCustomerInProgressRequests(customerPositionId);
      if (res2.Data.length > 0) {
        setResponseRequests(res2.Data);
      }
    } catch (error) {
      setMessageType("error");
    }
    setPresponseRequestsLoading(true);
  }
  const setDefaultAsync = async (Id) => {
    try {

        try {
          const response = await setDefault(Id);
         setForceUpdate(!forceUpdate)
        
        } catch (error) {
        
        }
      
    } catch (error) {}
  };  

  async function getCustomerPhoneNumbersAsync(pagNum = pageNum, searchSTR = search) {
    setLoadingPhoneNumbers(false);

    try {
      let pageSizeChangedByUser = getPageSize("ContactsInfoList")
      setPageSize(pageSizeChangedByUser)
      const res = await getCustomerPhoneNumbers(customerPositionId,pagNum, pageSizeChangedByUser, searchSTR, filterAndSort?.OrderFormat?.join(","), filterAndSort?.Filterlist);
      setResponsePhoneNumbers(res.Data);
      if (res.Data.Data.length > 0) {
        setPages(
          res.Data.TotalRecords > pageSizeChangedByUser
            ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser)
            : 1
        );
      }
    } catch (error) {
      setMessagePhoneNumbersType("error");
    }
    setLoadingPhoneNumbers(true);
  }

const deletePersonContactAsync=async(id)=>{

  try{
    await deletePersonContact(id)
    setForceUpdate(!forceUpdate)
  }catch(error){

  }
}

  useEffect(() => {
    getCustomerInfoAsync();
    getCustomerInProgressRequestsAsync()

  }, []);

  useEffect(() => {
    if(filterAndSort!=null){

      getCustomerPhoneNumbersAsync();
    }
  }, [forceUpdate,filterAndSort]);

  useEffect(() => {
    let settings = getGridSetting("ContactsInfoList");
    setFilterAndSort({ Filterlist: settings[0], OrderFormat: settings[1] });
  }, []);
  return (
    <>
    {
      showPhoneForm && 

            <ModalForm
                checkClose={false}
                onHide={() => setShowPhoneForm(false)}
                show={showPhoneForm}
                title="PersonContact"
              >
             <PhoneForm onHide={()=>setShowPhoneForm(false)} customerPositionId={customerPositionId} reset={()=>setForceUpdate(!forceUpdate)}/>
              </ModalForm>
    }
      <div className="card ">
        <div className="card card-body p-3">
          {loading ? (
            <>
              {response && response.HeaderInfo && (
                <Headerbar
                  headerContents={response.HeaderInfo}
                  hasBorder={true}
                />
              )}
              {!summarized ? (
                <>
                  <div className="card legendCard my-3">
                    <div className="legend">{trans("ContractsInfo")}</div>
                    {response && response.ContractsInfo.length > 0 ? (
                      <div className="card-body p-0">
                        <>
                          <DataGrid
                            disabled={true}
                            rowSelected=""
                            parentName={"ContractsInfoList"}
                            theadData={Object.keys(response.ContractsInfo[0])}
                            tbodyData={response.ContractsInfo}
                            minCellWidth={80}
                            startIndex={0}
                          />
                        </>
                      </div>
                    ) : (
                      <Message
                        message={"NoDataForPreview"}
                        type={messageType}
                      />
                    )}
                  </div>
                  <div className="card legendCard my-3">
                    <div className="legend ">{trans("LocksInfo")}</div>
                    {response && response.LocksInfo.length > 0 ? (
                      <div className="card-body p-0">
                        <>
                          <DataGrid
                            disabled={true}
                            rowSelected=""
                            parentName={"LocksInfoList"}
                            theadData={Object.keys(response.LocksInfo[0])}
                            tbodyData={response.LocksInfo}
                            minCellWidth={80}
                            startIndex={0}
                          />
                        </>
                      </div>
                    ) : (
                      <Message
                        message={"NoDataForPreview"}
                        type={messageType}
                      />
                    )}
                  </div>
                </>
              ) : (
                <></>
              )}

              <div className="card legendCard my-3">
                {presponseRequestsLoading ? (
                  <>
                    <div className="legend">
                      {trans("customerinprogressrequests")}
                    </div>
                    {responseRequests && responseRequests.length > 0 ? (
                      <div className="card-body p-0">
                        <>
                          <DataGrid
                            disabled={true}
                            rowSelected=""
                            parentName={"responseRequests"}
                            theadData={Object.keys(responseRequests[0])}
                            tbodyData={responseRequests}
                            minCellWidth={80}
                            startIndex={1}
                          />
                        </>
                      </div>
                    ) : (
                      <Message
                        message={"NoDataForPreview"}
                        type={requestsMessageType}
                      />
                    )}
                  </>
                ) : (
                  <Loading />
                )}
              </div>

              <div className="card legendCard my-3">
                {loadingPhoneNumbers?     
                <>
                <div className="legend">{trans("ContactsInfo")}</div>
                {responsePhoneNumbers?.Data && responsePhoneNumbers?.Data.length > 0 ? (
                  <div className="card-body p-0">
               


     {/* <div
                      onClick={()=>{setShowPhoneForm(true)}}
                      className="col-2 mb-1 btn btn-success btn-sm d-flex align-items-center justify-content-between "
                      style={{
                        width: "70px",
                        maxHeight: "30px",
                        marginRight: "20px",
                        minWidth: "70px",
                      }}
                    >
                      <>
                        <span className=" font-size-md ms-2 ">
                          {trans("add")}
                        </span>
                        <FontAwesomeIcon
                          size="xs"
                          icon={["fas", "plus"]}
                          className="color_text_light d-flex Requests__chatbox-reply-btn mx-1 p-1"
                          color="white"
                        />
                      </>
                    </div> */}
                    <>
                      <DataGrid
                        ViewParametr={"NotSeen"}
                        handlefiltering={(str: any) => {
                          str.Filterlist != undefined
                            ? setFilterAndSort(str)
                            : setFilterAndSort({
                                ...filterAndSort,
                                Filterlist: str,
                              });
                        }}
                        filterStr={filterAndSort.Filterlist}
                        orderFormatList={filterAndSort.OrderFormat}
                        orderFormat={(order) => {
                          setFilterAndSort({
                            ...filterAndSort,
                            OrderFormat: order,
                          });
                        }}
                        customFuction={customFuction}
                        selectedRowObjectCallback={(e)=>setSelectedObj(e)}
                        handleDelete={(e)=>{Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete ,()=> deletePersonContactAsync(selectedObj.Id))}}
                        rowSelected={selectedObj}
                        firstColumnOprationCustom={{show:true,function:()=>{
                          setShowPhoneForm(true)
                        },iconName:'plus'}}
                        parentName={"ContactsInfoList"}
                        totalRecords={responsePhoneNumbers.Data.find((item)=>item.Id==GUID_EMPTY)?0:responsePhoneNumbers.TotalRecords >0?responsePhoneNumbers.TotalRecords:0}
                        theadData={Object.keys(responsePhoneNumbers.Data[0])}
                        tbodyData={responsePhoneNumbers.Data.map((item)=>item.Id==GUID_EMPTY?{...item,Id:null}:item)}
                        minCellWidth={80}
                        startIndex={2}
                        pageNum={pageNum}
                        pageSize={pageSize}
                        HandleNextPage={handleNextPage}
                        HandlePrevPage={handlePrevPage}
                        handlechangePageSize={handleChangePageSize}
                        first={() => { getCustomerPhoneNumbersAsync(pages); setPageNum(pages) }}
                        end={() => { getCustomerPhoneNumbersAsync(1); setPageNum(1) }}
                        handleGoPage={handleGoPage}
                      />
                    
                    </>
                  </div>
                ) : (
                  <Message message={"NoDataForPreview"} type={messagePhoneNumbersType} />
                )}
                </>
                :<Loading/>}
              </div>

              {!response && !summarized && (
                <Message message={"NoDataForPreview"} type={messageType} />
              )}
            </>
          ) : (
            <Loading />
          )}
        </div>
      </div>
    </>
  );
};
